<script setup>
import { defineProps } from 'vue';
import CartaoPrincipal from './CartaoPrincipal/CartaoPrincipal.vue';
import CartaoItens from '../EditarDado/CartaoItens.vue';
import CartaoDatas from './CartaoDatas/CartaoDatas.vue';

defineProps({
    dado: { type: Object, default: () => ({}) },
    disabled: { type: Boolean, default: true },
    itensDaOS: { type: Array, default: () => [] },
    historico: { type: Array, default: () => [] },
});
</script>

<template>
    <div class="c-conteudo-modal">
        <CartaoPrincipal :dado="dado" :disabled="disabled" />
        <CartaoItens :itens="itensDaOS" :historico="historico" :disabled="true" />
        <CartaoDatas :dado="dado" :disabled="disabled" />
    </div>
</template>

<style scoped>
.c-conteudo-modal {
    display: grid;
    gap: 8px;
    align-content: start;
}
</style>
